<template>
    <div>
        <div class="classNav-component">
            <ul :key="foodsNav.length">
                <li v-for="(item,index) in foodsNav" :key="item.id" :data-id="item.id" :data-index="index">
                    <a href="javascript:void(0)" @click="goList(item.type,index)">{{ item.title }}</a>
                </li>
                <!-- <router-link 
                        v-for="(item,index) in foodsNav" 
                        :to="getData.path+item.id" 
                        tag="li" 
                        :key="item.id" 
                        :data-id="item.id" 
                        :data-index="index"
                        activeClass="classNav-bg">
                    {{ item.title }}
                </router-link> -->
            </ul>
        </div>
        <router-view />
    </div>
</template>

<script>
export default {
    name:'classNav',
    data(){
        return{
            foodsNav:[],
            typeID: 0
        }
    },
    components:{
  
    },
    props:['getData'],
    methods: {
        /* 本地获取数据 */
        getLocalDataByFetch(callBack){
            fetch('/assets/json/dqList.json')
                .then((res) => {
                    return res.json();
                })
                .then((data) => {
                    callBack && callBack(data);
                })
        },
        /* 过滤数据 得到特定数据类型 */
        filterClassList(data,dataType){
            for(var item of data){
                if(item['dataType'] == dataType){
                    return item.classList;
                }
            }
        },
        goList(type,index){
            // console.log("path:"+type);
            this.$router.push({path:`${this.getData.path}${type}`});
            this.currentItem(index);
        },
        currentItem(index){ // 选中的颜色
            var curLi = document.querySelectorAll('.classNav-component ul li');
            for(var i = 0;i < curLi.length;i++){
                curLi[i].style.background = '#f3f3f3';
                var oa = curLi[i].querySelectorAll('a')
                oa[0].style.color = '#000';
            }
            curLi[index].style.background = '#eb6100';
            var lia = curLi[index].querySelectorAll('a')
            lia[0].style.color = '#fff'; 
        }
    },
    mounted() {
        var This = this;
        if(this.getData.type){
            this.typeID = this.getData.type;
        }else{
            this.typeID = 0;
        }
        var promise = new Promise(function(resolve){
            This.getLocalDataByFetch(function(data){
                This.foodsNav = This.filterClassList(data.fondData,'food')[This.typeID].data;
                if(This.foodsNav){ // 如果 foodsNav 不为空，那么异步调用，使当前按钮变色
                    resolve();
                }
            });
        });
        promise.then(function(){
            var defaultGo = ['1-zc-daiwei','2-xd-biaohua','3-xc-zhushilei','4-yp-bingbangxuegao']
            This.goList(defaultGo[This.typeID],0)
        })
    },
    updated(){
  
    }
}
</script>
<style lang="less">
@rem: 40rem;
@w100: 640/@rem;
.justify {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.auto(@w) {
    width: @w/@rem;
    margin: 0 auto;
}
// 圆角
.radius(@radius) {
    border-radius: @radius/@rem @radius/@rem @radius/@rem @radius/@rem;
}
.linefont(@lineHeight, @fontSize, @color) {
    line-height: @lineHeight/@rem;
    font-size: @fontSize/@rem;
    color: @color;
}
.backgroundUrl(@img) {
    background: url(@img) no-repeat center / contain;
}
.aimg(@h) {
    a {
        display: block;

        img {
            width: 100%;
            height: @h/@rem;
        }
    }
}
.classNav-component{
    ul{
        .auto(610);
        &:extend(.justify);
        li{
            width: 140/@rem;
            .linefont(56, 20, #000);
            background: #f3f3f3;
            margin-bottom: 15/@rem;
            a{
                display: block;
                .linefont(56, 20, #000);
            }
        }
        .classNav-bg{
            background: #eb6100;
            color: #fff;
        }
    }
}
</style>